
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/san-pham-dich-vu",
      function () {
        return require("private-next-pages/san-pham-dich-vu/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/san-pham-dich-vu"])
      });
    }
  